<template>
    <div :class="[$style['pt-page-factor-filter'],displayVertical ? $style['isVertial'] :'']" class="page-factor-filter-top">
        <div :class="$style['pt-factor-filter-labels']">
            <div v-for="(item,index) in labels" :key="index" :class="$style['pt-factor-filter-labels__item']">
                <label>{{item.label}}：</label>
                <wt-selector v-if="item.type=='select'" :class="item.class" :multiple="item.multiple" :options="item.options" :props="item.props" :disabled="item.disabled"
                :filterable="item.filterable" :clearable="item.clearable" :value="crrentValue[item.value]" :valueFileds="item.value"
                @change="changeSelect" :loading="item.loading"></wt-selector>
                <wt-input v-else-if="item.type=='input'"  v-model="crrentValue[item.value]"  :clearable="item.clearable" :placeholder="item.placeholder"></wt-input>
                <pt-time-slot v-else-if="item.type=='time-slot'" :startLabel="item.startName"
                :endLabel="item.endName" @change="timeChange" :startTime="(crrentValue[item.value]&&crrentValue[item.value][item.startName])||crrentValue[item.startName]"
                :endTime="(crrentValue[item.value]&&crrentValue[item.value][item.endName])||crrentValue[item.endName]" :index="item.value||index"></pt-time-slot>
                <pt-price-slot :minLabel="item.minName" :maxLabel="item.maxName" v-else-if="item.type=='price-slot'||item.type=='number-slot'"
                :type="item.type=='number-slot'?'number':'price'" :minPrice="(crrentValue[item.value]&&crrentValue[item.value][item.minName])||crrentValue[item.minName]"
                :maxPrice="(crrentValue[item.value]&&crrentValue[item.value][item.maxName])||crrentValue[item.maxName]" :minPlaceholder="item.minPlaceholder"
                :maxPlaceholder="item.maxPlaceholder" @change="priceChange" :clearable="item.clearable"></pt-price-slot>
                 <pt-address-select v-else-if="item.type==='address-select'" @change="addressChange" v-model="crrentValue[item.value]" :labelValue="item.value" :clearable="item.clearable" :showElement="item.addressShowElement"></pt-address-select>
            </div>
             <div :class="[$style['pt-page-menu-filter-button'],displayVertical ? $style['addPadding'] :'']">
           <slot/>
        </div>
           <slot name="right" :class="$style['pt-page-factor-filter-right']"/>
        </div>

    </div>
</template>
<script>
import { isEmptyObject, cashCount } from '@/utils/formUtils'
import ptAddressSelect from 'cps/base/pt-address-select/withData'
export default {
  name: 'pt-page-factor-filter',
  components: {
    ptAddressSelect
  },
  props: {
    labels: {
      type: [Array, Function],
      default: function () {
        return []
      }
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    displayVertical: {
      type: Boolean,
      default: false
    },
    isQueryRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      crrentValue: this.value
    }
  },
  watch: {
    value (val) {
    //   if (isEmptyObject(val)) {
    //     this.crrentValue = val
    //   }
      if (JSON.stringify(val) !== JSON.stringify(this.crrentValue)) {
        this.crrentValue = JSON.parse(JSON.stringify(val))
      }
    //   this.crrentValue = JSON.parse(JSON.stringify(val))
    },
    crrentValue: {
      handler: function (val) {
        for (var i in val) {
          if (this.labels && this.labels.length) {
            this.labels.forEach(item => {
              if (!val[i] && i === item.value && item.type === 'select' && item.multiple) {
                val[i] = []
              }
            })
          }
        }
        this.$emit('input', JSON.parse(JSON.stringify(val)))
      },
      deep: true
    }
  },
  methods: {
    addressChange (val, filed) {
      this.$set(this.crrentValue, filed, val)
      this.$emit('input', JSON.parse(JSON.stringify(this.crrentValue)))
    },
    changeSelect (val, filed) {
      if (filed) {
        this.$set(this.crrentValue, filed, val)
      }
      this.$emit('input', JSON.parse(JSON.stringify(this.crrentValue)))
    },
    // 将参数传到router中
    getAddRouter (params) {
      if (this.isQueryRouter) {
        let query = this.$route.query
        for (var key in params) {
          if (typeof (params[key]) === 'object') {
            if (!isEmptyObject(params[key])) {
              for (var key1 in params[key]) {
                if (!params[key][key1]) {
                  this.$delete(params[key], key1)
                }
              }
              params = { ...params, ...params[key] }
            }
            this.$delete(params, key)
          }
          if (!params[key]) {
            this.$delete(params, key)
          }
        }
        this.$router.push({ name: this.$route.name, query: { page: query.page, ...params } })
      }
    },
    timeChange (val) {
      let newobj = {}
      if (this.labels && this.labels.length) {
        this.labels.forEach(item => {
          if (item.type === 'time-slot' && item.value === val.index) {
            newobj[item.value] = val
          }
        })
      }
      if (val.index) {
        Object.assign(this.crrentValue, newobj)
      } else {
        Object.assign(this.crrentValue, val)
      }
      this.$emit('input', this.crrentValue)
    },
    priceChange (val) {
      let newobj = {}
      if (this.labels && this.labels.length) {
        this.labels.forEach(item => {
          if ((item.type === 'price-slot' || item.type === 'number-slot') && item.value) {
            newobj[item.value] = val
          }
        })
      }
      Object.assign(this.crrentValue, newobj)
      this.$emit('input', this.crrentValue)
    },
    queryRouterData () {
      if (this.isQueryRouter) {
        let query = this.$route.query
        this.crrentValue = { ...query }
        if (this.labels && this.labels.length) {
          this.labels.forEach(item => {
            if (item.type === 'time-slot') {
              this.crrentValue[item.value] = this.crrentValue[item.value] || {}
              this.crrentValue[item.value][item.startName] = (query[item.startName] && query[item.startName]) || null
              this.crrentValue[item.value][item.endName] = (query[item.endName] && query[item.endName]) || null
              if (this.crrentValue[item.startName]) {
                this.$delete(this.crrentValue, item.startName)
              }
              if (this.crrentValue[item.endName]) {
                this.$delete(this.crrentValue, item.endName)
              }
            }
            if (item.type === 'price-slot') {
              this.crrentValue[item.value] = this.crrentValue[item.value] || {}
              this.crrentValue[item.value][item.maxName] = (query[item.maxName] && cashCount(query[item.maxName], true)) || null
              this.crrentValue[item.value][item.minName] = (query[item.minName] && cashCount(query[item.minName], true)) || null
              if (this.crrentValue[item.maxName]) {
                this.$delete(this.crrentValue, item.maxName)
              }
              if (this.crrentValue[item.minName]) {
                this.$delete(this.crrentValue, item.minName)
              }
            }
            if (item.type === 'select') {
              if (item.multiple) {
                this.crrentValue[item.value] = this.crrentValue[item.value] || []
                for (var key in this.crrentValue) {
                  if (!isNaN(Number(key))) {
                    this.crrentValue[item.value].push(this.crrentValue[key])
                    this.$delete(this.crrentValue, key)
                  }
                }
              } else {
                let currentValue = item.props && item.props.value ? item.options[0] && item.options[0][item.props.value] : item.options[0] && item.options[0].value
                if (typeof currentValue === 'number' && this.crrentValue && typeof this.crrentValue[item.value] === 'string') {
                  this.crrentValue[item.value] = Number(this.crrentValue[item.value])
                }
              }
            }
            if (item.type === 'address-select') {
              this.crrentValue[item.value] = this.crrentValue[item.value] || {}
              if (!item.addressShowElement || item.addressShowElement.province) {
                if (item.provinceGbCode) this.crrentValue[item.value][item.provinceGbCode] = this.crrentValue[item.provinceGbCode] || null
                else {
                  // this.crrentValue[item.value].provinceGbCode = this.crrentValue.provinceGbCode || null
                  this.$set(this.crrentValue[item.value], 'provinceGbCode', (this.crrentValue.provinceGbCode || null))
                }
              }
              if (!item.addressShowElement || item.addressShowElement.city) {
                if (item.cityGbCode) this.crrentValue[item.value][item.cityGbCode] = this.crrentValue[item.cityGbCode] || null
                else {
                  // this.crrentValue[item.value].cityGbCode = this.crrentValue.cityGbCode || null
                  this.$set(this.crrentValue[item.value], 'cityGbCode', (this.crrentValue.cityGbCode || null))
                }
              }
              if (!item.addressShowElement || item.addressShowElement.district) {
                if (item.districtGbCode) this.crrentValue[item.value][item.districtGbCode] = this.crrentValue[item.districtGbCode] || null
                else {
                  // this.crrentValue[item.value].districtGbCode = this.crrentValue.districtGbCode || null
                  this.$set(this.crrentValue[item.value], 'districtGbCode', (this.crrentValue.districtGbCode || null))
                }
              }
            }
          })
        }
        if (!isEmptyObject(query)) {
          this.$delete(this.crrentValue, 'page')
          this.$emit('input', JSON.parse(JSON.stringify(this.crrentValue)))
          this.$emit('Filter', true)
        }
      }
    }
  },

  created () {
    this.queryRouterData()
  }
}
</script>
<style module lang="less">
.pt-page-factor-filter{
    display: flex;
    margin: 15px 0;
:global
.el-button{
    padding: 0.12rem 0.4rem;
    margin-right: 30px;
    margin-bottom: 20px;
    &:last-child{
      margin-right: 0;
    }
    &.el-button--text{
        padding: 12px 0;
    }
}
}

.pt-factor-filter-labels{
    display: flex;
    flex-wrap: wrap;
    >div{
        margin-right: 40px;
    }
}
.pt-factor-filter-labels__item{
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    :global
    .wt-input{
        display: flex;
        width: 200PX;
    }
    label{
        margin-right: 10px;
    }
    :global
    .wt-selector{
        width: 200PX;
        display: flex;
        .el-select__tags{
            max-width: 180Px;
            .el-tag--info{
                white-space: inherit;
                display: inline-table
            }
        }

    }
    :global
    .el-date-editor{
        width: 200PX;
    }
}

// .isVertial{
//     display: block;
// }
.addPadding{
    // padding:20px 0;
    width: 100%
}
.pt-page-factor-filter-right{
    float: right
}
</style>
